<template>
  <section v-home-reveal class="seasons" :aria-label="t('homeFeaturePalettesTitle')">
    <div class="head">
      <h2>{{ t('homeFeaturePalettesTitle') }}</h2>
      <button type="button" class="more" @click="scrollToFrames">
        {{ t('homeSeasonPreviewMore') }}
      </button>
    </div>

    <ul class="grid">
      <li v-for="season in seasons" :key="season.titleKey">
        <div class="swatches" aria-hidden="true">
          <span
            v-for="swatch in season.swatches"
            :key="swatch"
            :style="{ background: swatch }"
          ></span>
        </div>
        <h3>{{ t(season.titleKey) }}</h3>
        <p>{{ t(season.traitKey) }}</p>
      </li>
    </ul>
  </section>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { HOME_SEASON_PREVIEWS } from './home.data';
import { vHomeReveal } from './home-reveal';

export default defineComponent({
  directives: {
    homeReveal: vHomeReveal,
  },
  setup() {
    const { t } = useI18n();

    const scrollToFrames = () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.getElementById('home-frames')?.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start',
      });
    };

    return {
      t,
      seasons: HOME_SEASON_PREVIEWS,
      scrollToFrames,
    };
  },
});
</script>
<style scoped lang="scss">
.seasons {
  margin: 0 0 56px;
}

.head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 18px;
}

h2 {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: rgba(246, 243, 238, 0.62);
}

.more {
  padding: 0;
  border: 0;
  background: none;
  font-size: 13px;
  font-weight: 500;
  color: #52dbff;
  cursor: pointer;
}

.more:hover {
  color: #8ae7ff;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

li {
  padding: 16px 16px 18px;
  border: 1px solid rgba(246, 243, 238, 0.12);
  border-radius: 22px;
  background: rgba(20, 16, 24, 0.48);
  text-align: left;
  transition: transform 0.35s ease, border-color 0.35s ease;
}

li:hover {
  transform: translateY(-4px);
  border-color: rgba(246, 243, 238, 0.24);
}

.swatches {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
  margin: 0 0 16px;
}

.swatches span {
  display: block;
  aspect-ratio: 1;
  border-radius: 10px;
  border: 1px solid rgba(246, 243, 238, 0.12);
  box-shadow: inset 0 0 0 1px rgba(20, 16, 24, 0.12);
}

h3 {
  margin: 0 0 6px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

p {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: rgba(246, 243, 238, 0.62);
}

@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 560px) {
  .head {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  li {
    transition: none;
  }

  li:hover {
    transform: none;
  }
}
</style>
